<div class="avi-skip-link clr-wrapper">
    <a
        href=""
        (click)="focusMain($event)"
    >
        {{ l10nKeys.skipToMainContent | vtranslate }}
    </a>
</div>
